// Verus.js
// import BackButton2 from "./BackButton2";

const Versus = (props) => {
  return (
    <div>
      {/* <BackButton2 /> */}
      <div className="versus">
        <h2>VS</h2>
      </div>
    </div>
  );
};

export default Versus;
